import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Alert,
  TextField, Typography,
} from "@mui/material";
import axios from "../../../config/axiosConfig";

const formatFecha = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

const RecibirTraspasoDialog = ({ open, onClose, traspaso, onRecibido }) => {
  const [recibidoDetalle, setRecibidoDetalle] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setRecibidoDetalle("");
      setError("");
    }
  }, [open]);

  const handleGuardar = async () => {
    setSaving(true);
    setError("");
    try {
      await axios.patch(`/api/inventario-interno/traspaso/${traspaso.id}/recibir`, {
        recibido_detalle: recibidoDetalle.trim(),
      });
      onRecibido();
    } catch (e) {
      setError(e?.response?.data?.message || "Error al recibir el traspaso.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>Recibir {traspaso?.producto_nombre}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.5} sx={{ mt: 0.5 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <Typography variant="body2">
            <strong>Cantidad:</strong> {traspaso?.cantidad}<br />
            <strong>Desde:</strong> {traspaso?.id_sucursal_origen}<br />
            <strong>Enviado:</strong> {formatFecha(traspaso?.fecha_registro)}<br />
            <strong>Observación:</strong> {traspaso?.detalle || "-"}
          </Typography>
          <TextField
            size="small" label="Detalle de recepción" multiline minRows={2}
            value={recibidoDetalle} onChange={(e) => setRecibidoDetalle(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" onClick={handleGuardar} disabled={saving}>
          {saving ? "Guardando..." : "Recibir"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecibirTraspasoDialog;
